<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
  <g clip-path="url(#a)">
    <path fill-rule="evenodd" d="M6.5 3.5c-1.17 0-2.39.15-3.5.5-.75.25-1.4.55-2 1v14.6c0 .25.25.5.5.5.1 0 .15 0 .25-.05C3.15 19.3 4.85 19 6.5 19c1.7 0 4.15.65 5.5 1.5 1.35-.85 3.8-1.5 5.5-1.5 1.65 0 3.35.3 4.75 1.05.1.05.15.05.25.05.25 0 .5-.25.5-.5V5c-.6-.45-1.25-.75-2-1-1.11-.35-2.33-.5-3.5-.5-1.95 0-4.05.4-5.5 1.5-1.45-1.1-3.55-1.5-5.5-1.5Zm11 13.5c-1.336 0-3.136.401-4.5.986v-11.5c1.364-.584 3.164-.986 4.5-.986 1.2 0 2.4.15 3.5.5v11.5c-1.1-.35-2.3-.5-3.5-.5Z" clip-rule="evenodd"/>
  </g>
  <defs>
    <clipPath id="a">
      <path d="M0 0h24v24H0z"/>
    </clipPath>
  </defs>
</svg>
